import React from "react";
import AboutHeroSection from "../Components/About/AboutHeroSection.jsx";
import AboutOverview from "../Components/About/AboutOverview.jsx";

const AboutPage = () => {
  return (
    <main role="main">
      <AboutHeroSection />
      <AboutOverview />
    </main>
  );
};

export default AboutPage;
